module.exports = __webpack_public_path__ + "static/media/json.ac3822f4.png";